import { createContext } from 'react';

// The tenant + room the dashboard is operating on, taken from the URL path (/{tenant}/{room}).
const RoomContext = createContext(null);

export default RoomContext;
